// АНИМ.2: данные лиг для UI-анимации (цвета, индексы, RU/EN-имена).
//
// Отдельно от i18n/leagues.ts (там только winsToPromote/next), потому
// что сюда нужны UI-токены (color, accent) и индекс 0..6 для сцены
// LadderHologram.
//
// Имена должны совпадать с server/src/lib/leagues.ts (RU-имена в БД).

export interface LeagueUiDef {
  idx: number;          // 0..6
  ru: string;
  en: string;
  color: string;        // главный цвет (фон, акценты)
  accent: string;       // вторичный (шестиугольники, line-glow)
}

export const LEAGUES_UI: LeagueUiDef[] = [
  { idx: 0, ru: 'Трущобы',      en: 'Slums',         color: '#6B7080', accent: '#60657A' },
  { idx: 1, ru: 'Стритраннеры', en: 'Streetrunners', color: '#FF3D8F', accent: '#FF3D8F' },
  { idx: 2, ru: 'Нетраннеры',   en: 'Netrunners',    color: '#3DF0FF', accent: '#3DF0FF' },
  { idx: 3, ru: 'Фиксеры',      en: 'Fixers',        color: '#FF8A1F', accent: '#FFC83D' },
  { idx: 4, ru: 'Оперативники', en: 'Operatives',    color: '#C93DFF', accent: '#C93DFF' },
  { idx: 5, ru: 'Корпораты',    en: 'Corporates',    color: '#3D7DFF', accent: '#8FB2FF' },
  { idx: 6, ru: 'Высшая лига',  en: 'Big League',    color: '#FFB13D', accent: '#FFB13D' }
];

const BY_RU: Record<string, LeagueUiDef> = {};
LEAGUES_UI.forEach((l) => { BY_RU[l.ru] = l; });
BY_RU['Высшая Лига'] = BY_RU['Высшая лига'];

export function leagueByName(name: string | null | undefined): LeagueUiDef {
  if (!name) return LEAGUES_UI[0];
  return BY_RU[name] || LEAGUES_UI[0];
}

export function leagueByIdx(idx: number): LeagueUiDef {
  const clamped = Math.max(0, Math.min(idx, LEAGUES_UI.length - 1));
  return LEAGUES_UI[clamped];
}

export function isBigLeague(name: string | null | undefined): boolean {
  return name === 'Высшая лига' || name === 'Высшая Лига';
}
